import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ScreenTemplate.css"
import { NewScreen1Background, StickerFoodIsLoveLanguage } from "../../assets";

const ScreenTemplate = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {

        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-screen-new-3 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display">
                    {/* <h1>new screen content</h1> */}
                    <div className="frame">
                        <img
                            src={StickerFoodIsLoveLanguage}
                            alt=""
                        />
                    </div>
                    <div className="text-div part-2">
                        <p className="news">Food and flavors allow humans to be cultured Our dream is to be an avenue for people to connect with themselves & people around them and to become more curious about each other through food & flavors.</p>
                    </div>
                    <div className="text-div part-2">
                        <p className="news">Kuno culture is special because respecting traditional knowledge of fermentation is something that we hold dear in our hearts & basis for integrity in creating food. For example with tempe fermentation, we did a lot of trial and error to make tempe fungi happy in (not so sunny) Sweden. We do this so the tempe can taste as fresh, as delicious, and as authentic as we have it in Indonesia.</p>
                    </div>
                    <div className="text-div part-2">
                        <p className="news">Our ingredients also make our tempe sustainable & circular using organic locally sourced ingredients and made special with upcycled ingredient that adds to its unique flavours.</p>
                    </div>
                    <div className="text-div part-2">
                        <p className="news">But, truly its not us, its really the amazing mycelium that we combine with care and creativity with available ingredients to preserve this traditional oldie but goldie knowledge. After all, there must be a reason that mycelium fermentation like tempe has been a staple accessible protein source since 500 years ago!</p>
                    </div>
                    
                </div>

            </div>
        </>
        
    )
};

export default ScreenTemplate;